import React, {useContext, useEffect, useState} from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./Assets/Styles/main.css";
import SelectVariables from "./Pages/SelectVariables";
import SuggestedMarkets from "./Pages/SuggestedMarkets";
import Loader from "./Components/Loader";
import {DataContext} from "./Context/DataContext";
import getTopCountries from "./Services/Utils/getTopCountries";

function App() {
	// Loader settings
	const [loading, setLoading] = useState(true);

	// Page changes
	const {showedScreen, requestVariables, setRequestVariables, setActiveCountries} = useContext(DataContext);
	const [topCountries, setTopCountries] = useState();

	useEffect(() => {
		if (showedScreen === 1) {
			// Switch to "Select Variables" page
			setTopCountries(undefined);
			setRequestVariables({demanda: [], idioma: [], est_mercados: [], ecommerce: [], logistica: [], acceso: ["Minimis"]});
			setActiveCountries([false, false, false]);
		} else {
			// Switch to "Suggested Markets" page
			setLoading(true);
			getTopCountries(requestVariables).then((response) => {
				setTopCountries(response);
				setLoading(false);
			});
		}
		// eslint-disable-next-line
	}, [showedScreen]);

	return (
		<>
			{showedScreen === 1 ? <SelectVariables /> : loading ? <Loader /> : topCountries && <SuggestedMarkets topCountries={topCountries} />}
		</>
	);
}

export default App;
